<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Treatments"
          text=""
          class="elevation-1"
        >
          <v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="upsertDialog()"
            v-if="$can('upsert', 'treatment')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-data-table
            id="treatment_dataTable"
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon
                  >
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
              
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-text-field
                      clearable
                      md4
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      @input="filterChanged(filters[header.value])"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-autocomplete>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>{{ item.protocol.name }}</td>
                <td class="text-xs-left">{{ item.drug }}</td>
                <td class="text-xs-left">{{ item.min_dose }}-{{ item.max_dose }} {{ item.measure_unit }}</td>
                <td class="text-xs-right">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertDialog(item)">
                        <v-icon v-if="$can('upsert', 'treatment')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'treatment')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>{{$can('upsert', 'treatment') ? 'Edit Treatment' :'View Treatment' }}</span>
                  </v-tooltip>

                  <v-tooltip top v-if="$can('delete', 'treatment')">
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="treatmentItem = item; deleteDialog = true" class="ml-2">
                        <v-icon v-if="$can('delete', 'treatment')" v-on="on" color="primary">mdi-delete-forever</v-icon>
                      </a>
                    </template>
                    <span>Remove Treatment</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                </v-tooltip>

                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>

    <safety-delete-modal v-model="deleteDialog" entity="Treatment" :entityId="treatmentItem.drug + '/' + treatmentItem.protocol.name" @confirm="confirmDelete"/>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="treatment" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>

  </v-container>
</template>


<script>
import { normalizeFilters } from "@/utils/filters";
import { getList, remove } from "@/api/treatment";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "id",
        descending: true
      },
      paginationAlias: {
        protocol_id: "protocol.name",
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      treatmentItem: {protocol:{}},
      deleteDialog: false,
      rowsPerPageItems: [5,10,25],
      loading: true,
      items: [],
      totalItems: 0,
      headers: [
        { text: "Protocol", align: "left", value: "protocol_id"},
        { text: "Drug", value: "drug" },
        { text: "Dose (min-max)", value: "dose", sortable: false },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      // filters: {
      //   'protocol.sponsor_id': {
      //     value: this.$store.getters.sponsor_id
      //   },
      //   protocol_id: {
      //     type:'list',
      //     list: this.$store.getters.protocols,
      //     value: undefined,
      //     placeholder: 'Search',
      //     item_text:"name",
      //     item_value:"id"
      //   },
      //   drug: {
      //     type:'text',
      //     replace: "VALUE%"
      //   }
      // }
    };
  },
  computed: {
    filters() {
      return {
        protocol_id: {
          type:'list',
          list: this.$store.getters.protocols,
          value: undefined,
          placeholder: 'Choose',
          item_text:"name",
          item_value:"id"
        },
        drug: {
          type:'text',
          replace: "VALUE%",
          placeholder: 'Search',
        },
        'protocol.sponsor_id': {
          value: this.$store.getters.sponsor_id
        },
      }
    }
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
        if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        this.getData();
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
  },
  mounted() {
    
    this.getData();

    this.$root.$on('updateTreatments', () => {
      this.getData();
    });

    // this.$root.$on('sponsorChanged', (v) => {
    //   this.filters['protocol.sponsor_id'] = {
    //       value: this.$store.getters.sponsor_id
    //   };
    // });

  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },    
    getData() {
      this.loading = true;
      const filters = JSON.parse(JSON.stringify(this.filters));
      getList(normalizeFilters(filters), this.pagination).then(data => {
        this.items = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalItems = data.tot;
        this.loading = false;
      });
    },
    filterChanged(filter) {
      this.getData();
      console.log("Filter changed", filter)
    },
    sortAlias(col) {
      return this.paginationAlias[col] || col;
    },
    changeSort(column) {
      column = this.sortAlias(column);
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = true;
      }
      this.pagination = oldPagination;
    },
    upsertDialog(item = {}) {
      this.$store.dispatch(
        "app/openTreatmentDialog",
        JSON.parse(JSON.stringify(item))
      );
    },
    confirmDelete() {
      remove(this.treatmentItem.id).then( id => {
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Treatment deleted successfully",
          color: "success"
        });
      }).catch( errorData => {
        let message = errorData.response.data.message;
        if (message.search("foreign key constraint") ) {
           message = "This record has already been used and cannot be removed";
        }
        this.$store.dispatch("app/openSnackbar", {
          message: "Treatment Delete error : " +  message,
          color: "error"
        });
      });
    }
  }
};
</script>

<style lang="scss">
#treatment_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
}
</style>